module.exports = __webpack_public_path__ + "static/media/bg.6be11242.png";